/**
 * Action definitions for the core content pack.
 *
 * Consolidates all action definitions for registration.
 */

import type { ActionDefinition } from '@idle-depths/shared';

import { MINING_BASIC_ACTIONS } from './mining-basic';

/**
 * All core action definitions.
 */
export const CORE_ACTIONS: ActionDefinition[] = [...MINING_BASIC_ACTIONS];

/**
 * Type guard for ActionDefinition.
 *
 * Used by ContentRegistry for validation.
 *
 * @param data - Unknown data to validate
 * @returns True if data is a valid ActionDefinition
 */
export function isActionDefinition(data: unknown): data is ActionDefinition {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const obj = data as Record<string, unknown>;

  return (
    typeof obj.id === 'string' &&
    typeof obj.skillId === 'string' &&
    typeof obj.name === 'string' &&
    typeof obj.description === 'string' &&
    typeof obj.levelRequired === 'number' &&
    obj.levelRequired >= 1 &&
    typeof obj.baseTimeMs === 'number' &&
    obj.baseTimeMs > 0 &&
    typeof obj.baseXP === 'number' &&
    obj.baseXP >= 0 &&
    Array.isArray(obj.requirements) &&
    Array.isArray(obj.outputs)
  );
}

export * from './mining-basic';
